import _ from "lodash";
import { useContext, useEffect, useState } from "react";
import ConfigurationViewPage from "../../../components/management/PartnerGenericConfigurationPages/ConfigurationViewPage";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { paths } from "../../../routes/paths";
import "./PartnerConfigurationViewPage.scss";

export default function PartnerConfigurationPage() {
  const [configData, setConfigData] = useState({
    package_partner: "",
    receipt_partner: "",
    generic_notification_partner: "",
  });
  const { programConfigurations } = useContext(GlobalConfigContext);

  const configKey = "partner_configuration";
  const editPath = `/${paths.system_setting}/${paths.partner_configuration}/edit`;

  useEffect(() => {
    const configuration = _.find(programConfigurations, {
      key: configKey,
    });
    if (configuration !== null && configuration !== undefined) {
      setConfigData(configuration.value?.data);
    }
  }, [programConfigurations]);

  const breadcrumbPath = [
    {
      href: "/",
      label: "Home",
    },
    {
      label: "System Setting",
      href: `../../../${paths.system_setting}`,
    },
    {
      label: "Partner Configuration View",
      href: `../../../${paths.system_setting}/${paths.partner_configuration}`,
    },
  ];

  return (
    <ConfigurationViewPage
      configKey={configKey}
      headerText="Partner Configuration View"
      description="Setup and configuration details for partners"
      breadcrumbPath={breadcrumbPath}
      editPath={editPath}
    >
      <h5 className="$color-text-primary">
        Package Partner:{" "}
        <span className="value">{configData["package_partner"]}</span>
      </h5>
      <h5 className="$color-text-primary">
        Receipt Partner:{" "}
        <span className="value">{configData["receipt_partner"]}</span>
      </h5>
      <h5 className="$color-text-primary">
        Generic Notification Partner:{" "}
        <span className="value">{configData["generic_notification_partner"]}</span>
      </h5>
    </ConfigurationViewPage>
  );
}
